import React from 'react'
import TextField from '@material-ui/core/TextField'
import { useTranslation } from 'react-i18next'
import makeStyles from '@material-ui/core/styles/makeStyles'
import classNames from 'classnames'
import Tooltip from 'components/Shared/Table/TableTooltip'
import { AvenirRegular } from 'styles/variables'
import moment from 'moment'

const useStyles = makeStyles({
  defaultStyles: {
    width: '310px',
    marginBottom: '24px',
  },
  stylesWithHelperText: {
    width: '310px',
    '& .MuiFormHelperText-root': {
      color: 'orange',
      fontFamily: AvenirRegular,
    },
  },
  changedField: {
    backgroundColor: 'rgba(33,187,58, 0.2)',
  },
})

export function ReadOnlyTextField({
                                    value,
                                    previousValue,
                                    label,
                                    additionalLabelText = '',
                                    variantValue = 'filled',
                                    disabled = false,
                                    InputClass,
                                    className,
                                    multiline,
                                    helperText,
                                    asDateTime = false,
                                    asDate = false,
                                    ...rest
                                  }) {

  const { t } = useTranslation()
  const classes = useStyles()
  const displayedPreviousValue = (previousValue && previousValue.value !== value) ? (previousValue.value ? previousValue.value : '-') : undefined

  if (value && (asDateTime || asDate)) {
    value = moment(value).format(asDateTime ? 'DD-MM-YYYY HH:mm' : 'DD-MM-YYYY')
  }

  const dataField = <TextField
    InputProps={{
      disableUnderline: variantValue === 'filled',
      classes: {
        input: classNames(InputClass, displayedPreviousValue && classes.changedField),
      },
    }}
    InputLabelProps={{
      shrink: true,
      disableAnimation: true,
    }}
    label={`${t(label)} ${additionalLabelText}`}
    className={classNames(helperText
        ? classes.stylesWithHelperText
        : classes.defaultStyles,
      className, !disabled && 'clearDisabled')}
    variant={variantValue}
    disabled
    value={value ? value : '-'}
    helperText={helperText}
    multiline={multiline}
    {...rest}
  />

  return (displayedPreviousValue ?
      <Tooltip title={displayedPreviousValue}>
        {dataField}
      </Tooltip>
      : dataField
  )
}

